// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import Signup from './components/Signup';
import Login from './components/Login';
import VerifyOTP from './components/VerifyOTP';
import AddCategory from './components/AddCategory';
import AddProduct from './components/AddProduct';
import CategoryList from './components/CategoryList';
import ProductList from './components/ProductList';
import AddCoupon from './components/AddCoupon';
import CouponList from './components/CouponList';
import OrdersList from './components/OrdersList';
import EditProduct from './components/EditProduct';

function App() {
  return (
    <Router>
      <div className="container">
       <nav className="navbar navbar-expand-lg navbar-light bg-light">
      <div className="container-fluid">
        {/* Brand */}
        <Link className="navbar-brand" to="/">Devesh Meditech Admin Panel</Link>

        {/* Toggle Button for mobile */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#adminNavbar"
          aria-controls="adminNavbar"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Navbar Links */}
        <div className="collapse navbar-collapse" id="adminNavbar">
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
            {/* <li className="nav-item">
              <Link className="nav-link" to="/add-category">Add Category</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/add-product">Add Product</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/categories">Categories</Link>
            </li> */}
            {/* <li className="nav-item">
              <Link className="nav-link" to="/products">Products</Link>
            </li> */}
            {/* <li className="nav-item">
              <Link className="nav-link" to="/add-coupon">Add Coupon</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/coupon">Coupon List</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/order">Order List</Link>
            </li> */}
          </ul>
        </div>
      </div>
    </nav>
        <Routes>
          <Route path="/" element={<Login />} />

          <Route path="/signup" element={<Signup />} />
          <Route path="/login" element={<Login />} />
          <Route path="/verify-otp" element={<VerifyOTP />} />
          <Route path="/add-category" element={<AddCategory />} />
          <Route path="/add-product" element={<AddProduct />} />
          <Route path="/categories" element={<CategoryList />} />
          <Route path="/products" element={<ProductList />} />
          <Route path="/add-coupon" element={<AddCoupon />} />
          <Route path="/coupon" element={<CouponList />} />
          <Route path="/order" element={<OrdersList />} />
<Route path="/edit-product/:id" element={<EditProduct />} />

        </Routes>
      </div>
    </Router>
  );
}

export default App;
